<template>
  <div>
    <div class="header">
      <Header title="售后帮助" />
    </div>
    <div class="container">
      <Cell
        v-if="showCsBtn"
        title="联系客服"
        is-link
        @click="goCs"
      />
    </div>
  </div>
</template>

<script>
import { Cell } from 'vant';
import { Native } from '@hb/mbridge';
// import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { showThirdPage } from '~mall/common/utils/jumpUrl';
import { isHelloFamilyApp } from '~mall/common/env/env';
import Header from '~mall/components/Header.vue';

export default {
  name: 'AfterSale',
  components: {
    Header,
    Cell,
  },
  computed: {
    showCsBtn() {
      return this.$route.query.showCsBtn;
    },
    sharedUbtBizInfo() {
      try {
        return JSON.parse(this.$route.query.sharedUbtBizInfo);
      } catch (e) {
        return {};
      }
    },
    csUrl() {
      return this.$route.query.csUrl;
    },
  },
  mounted() {
    if (!isHelloFamilyApp) {
      Native.setPageTitle({
        title: '售后帮助',
      });
    } else {
      Native.callNative({
        classMap: 'NavBar',
        method: 'setStatusBar',
        params: { isShowStatusBar: true },
      });
      Native.callNative({
        classMap: 'NavBar',
        method: 'setStatusBarColor',
        params: { isShowStatusBar: true, isDarkFont: false, colorCode: '#ffffff' },
      });
    }
  },
  methods: {
    goCs() {
      // UBT.clickButton({
      //   buttonName: 'APP_优惠券商城_购买记录详情页_联系客服',
      //   pageId: 'mkt_couponmall_orderdetail',
      //   categoryId: 'market',
      // });
      // UBT.clickButton({
      //   pageId: 'platform_couponMall_orderDetails',
      //   buttonName: 'platform_couponMall_customerService_click',
      //   categoryId: 'platform',
      //   businessInfo: this.sharedUbtBizInfo,
      // });
      showThirdPage(this.csUrl);
    },
  },
};
</script>

<style scoped lang="less">
.container {
  padding: 5px 0;
}
</style>
